<template>
	<div class="contractorList ">
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="disBetween searchLeft">
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.repairUserId" placeholder="请输入承包商名称">
						</el-input>
					</div>
					<div class="myinputBox myinputBox2">
						<el-cascader ref="cascader1" :props="props" :options="areaList" v-model="areaValue" clearable
							@change="handleChange($event,1)" placeholder="请选择承包社区名称"></el-cascader>
					</div>
					<el-button type="success" @click="toSearch">查询</el-button>
				</div>
				<el-button type="success" @click="exportData">导出</el-button>
			</div>

		</div>
		<div class="listBox">
			<div style="height: 100%;width: 100%;" v-loading="loading">
				<div class="content myTable">
					<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="contractId" label="编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="repairUserName" label="承包商名称">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="repairUserPhone" label="联系方式">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="checkFlag" label="审核状态">
							<template slot-scope="scope">
								<span>{{getName(scope.row.checkFlag,flagList)}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="承包社区">
						</el-table-column>
						<!-- <el-table-column show-overflow-tooltip prop="contractorStatus" label="状态">
						</el-table-column> -->
						<el-table-column show-overflow-tooltip prop="marginAmount" label="缴纳保证金">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="marginDeductMoney" label="已扣除保证金">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="marginBalance" label="保证金余额">
						</el-table-column>
						<el-table-column label="操作" width="150">
							<template slot-scope="scope">
								<el-button v-if="scope.row.checkFlag==1" type="text" size="small"
									@click="itemClick(scope.row,1)">资质审核</el-button>
								<el-button v-if="scope.row.checkFlag!=1" type="text" size="small"
									@click="itemClick(scope.row,1)">查看</el-button>
								<el-button v-if="scope.row.checkFlag==2 || scope.row.checkFlag==5" type="text"
									size="small" @click="itemClick(scope.row,4)">合同管理</el-button>
								<el-button type="text" size="small" @click="itemClick(scope.row,2)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :visible.sync="dialogVisible" width="80%">
			<div class="dialogBox3">
				<div class="contBox">
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">人员名称:</span>
							<span class="valueBox">{{creatObj.repairUserName}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">人员编号:</span>
							<span class="valueBox">{{creatObj.repairUserId}}</span>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="elBox">
							<span class="nameBox">联系方式:</span>
							<span class="valueBox">{{creatObj.repairUserPhone}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">身份证号:</span>
							<span class="valueBox">{{creatObj.certificateId}}</span>
						</div>
					</div>
					<!-- <div class="itemBox ">
						<span>人员状态：{{creatObj.repairUserStatus==1?"正常":creatObj.repairUserStatus==2?"停工":""}}</span>
					</div> -->


					<div class="itemBox  disStart">
						<div class="imgBox"><span>身份证正反面照:</span>
							<div class=" disStart">
								<el-image class="img" error="暂无图片" :src="$basImgUrl+creatObj.certificateFrontUrl"
									:preview-src-list="[$basImgUrl+creatObj.certificateFrontUrl]">
								</el-image>
								<el-image class="img" :src="$basImgUrl+creatObj.certificateBackUrl"
									:preview-src-list="[$basImgUrl+creatObj.certificateBackUrl]">
								</el-image>
							</div>
						</div>
						<div class="imgBox"><span>电工证:</span>
							<div class=" disStart">
								<el-image class="img2" :src="$basImgUrl+creatObj.electricianCertificateUrl"
									:preview-src-list="[$basImgUrl+creatObj.electricianCertificateUrl]">
								</el-image>
							</div>
						</div>
					</div>
					<div class="itemBox  ">
						<div class="elBox elBox2">
							<span class="nameBox">管辖地区:</span>
							<span class="valueBox">{{creatObj.communityName}}</span>
						</div>
					</div>

					<div class="itemBox  ">
						<div class="elBox elBox2">
							<span class="nameBox">具体地址:</span>
							<span class="valueBox">{{creatObj.provinceName}}{{creatObj.cityName}}{{creatObj.areaName}}
								{{creatObj.address}}</span>
						</div>
					</div>
					<div class="itemBox  ">
						<div class="elBox elBox2">
							<span class="nameBox">申请权限:</span>
							<span class="valueBox">
								<span class="flag">
									{{creatObj.overhaulFlag==2?'故障检修权限':""}}
								</span>
								<span class="flag">
									{{creatObj.installFlag==2?'设备安装权限':""}}{{creatObj.installFag==2?'设备安装权限':""}}
								</span>
								<span class="flag">
									{{creatObj.initializeFlag==2?'初始化权限':""}}
								</span>
								<span class="flag">
									{{creatObj.bindFlag==2?'解绑设备权限':""}}
								</span>
								<span class="flag">
									{{creatObj.rechargeCardFlag==2?'转卡权限':""}}
								</span>
								<span class="flag">
									{{creatObj.communityFlag==2?'设备查看':""}}
								</span>
								<span class="flag">
									{{creatObj.expressFlag==2?'快递物流':""}}
								</span>
							</span>
						</div>
					</div>
					<div class="itemBox" v-if="creatObj.communityFlag==2">
						<div class="elBox elBox2">
							<span class="nameBox">负责社区:</span>
							<div class="communityBox">
								<div v-for="(item,inx) in creatObj.communityCenterIdList">
									<span>
										{{item.communityName}}
									</span>
									<span v-if="inx<creatObj.communityCenterIdList.length-1">
										,
									</span>
								</div>
							</div>
						</div>
					</div>
					<div class="itemBox  disStart" v-if="creatObj.checkFlag==2">
						<div class="imgBox"><span>电子合同(原稿):</span>
							<div class=" " v-if="creatObj.electronicContractUrl">
								<el-button round size="small" @click="tuDown(creatObj)" type="primary">查看</el-button>
							</div>
						</div>
					</div>
					<div v-if="creatObj.checkFlag>=4 && creatObj.checkFlag!=5 ">
						<div class="itemBox  disStart">
							<div class="imgBox"><span>盖章合同:</span>
								<div class=" " v-if="creatObj.electronicContractUrl">
									<el-button round size="small" @click="tuDown(creatObj)"
										type="primary">查看</el-button>
								</div>
							</div>
						</div>
						<div class="itemBox  disStart">
							<div class="elBox elBox2">
								<span class="nameBox">合同开始时间:</span>
								<span class="valueBox">{{creatObj.contractStartTime}}</span>
							</div>
						</div>
						<div class="itemBox disStart ">
							<div class="elBox elBox2">
								<span class="nameBox">保证金金额:</span>
								<span class="valueBox">{{creatObj.marginAmount}}元</span>
							</div>
							<div class="elBox elBox2">
								<span class="nameBox">合同结算周期:</span>
								<span class="valueBox">{{getName(creatObj.contractSettlementCycle,cycleList)}}</span>
							</div>
						</div>
						<div class="itemBox  disStart">
							<div class="elBox elBox2">
								<span class="nameBox">结算日期(次月):</span>
								<span class="valueBox">{{creatObj.settlementTime}}号</span>
							</div>
							<div class="elBox elBox2">
								<span class="nameBox">周期结算金额:</span>
								<span class="valueBox">{{creatObj.settlementAmount}}元</span>
							</div>
						</div>
					</div>

				</div>
				<div v-if="creatObj.checkFlag==1">
					<div class="titleBox">审核信息</div>
					<el-form :model="creatObj" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm"
						v-if="creatObj.checkFlag==1">
						<div class="diaItem diaItem2">
							<div class="diaTpye disStart">
								<el-form-item class="lableBox" label="审核结果:" prop="check">
									<div class="myinputBox4">
										<el-radio-group v-model="creatObj.check">
											<el-radio :label="2">通过,合同待审核</el-radio>
											<el-radio :label="3">不通过</el-radio>
										</el-radio-group>
									</div>
								</el-form-item>
							</div>
						</div>
						<div class="diaItem diaItem2" v-if="creatObj.check==3">
							<div class="diaTpye disStart">
								<el-form-item class="lableBox" label="审核内容:" prop="checkContent">
									<div class="myinputBox4">
										<el-input clearable v-model="creatObj.checkContent" placeholder="请输入审核内容">
										</el-input>
									</div>
								</el-form-item>
							</div>
						</div>
						<div class="diaItem diaItem2" v-if="creatObj.check==2">
							<div class="diaTpye disStart">
								<el-form-item class="lableBox" label="请上传合同" prop="file">
									<div class="myinputBox myinputBox3">
										<el-upload class="avatar-uploader disBetween" :auto-upload="autoUpload"
											:on-progress="onProgress" :before-upload="beforeUpload"
											:on-change="getFile1" action="certmanage" :on-remove="handleRemove"
											:limit="1" :on-exceed="handleExceed" :file-list="fileList">
											<el-button size="small" type="primary">点击上传</el-button>
										</el-upload>
									</div>
								</el-form-item>
							</div>
						</div>
					</el-form>
					<div class="contBox" v-else>
						<div class="itemBox  disStart">
							<div class="elBox elBox2">
								<span class="nameBox">审核结果:</span>
								<span
									class="valueBox">{{creatObj.checkFlag==2?"通过":creatObj.checkFlag==3?"不通过":""}}</span>
							</div>
						</div>
						<div class="itemBox  disStart">
							<div class="elBox elBox2">
								<span class="nameBox">审核内容:</span>
								<span class="valueBox">{{creatObj.checkContent}}</span>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div slot="footer" class="diabtnBox" v-if="creatObj.checkFlag==1">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="toSave('ruleForm1')">确定</el-button>
			</div>
			<div slot="footer" class="diabtnBox" v-else>
				<el-button type="primary" @click="dialogVisible = false">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="权限" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow1"
			width="40%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm4" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox4">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item label="权限:" prop="flag">
								<el-checkbox-group v-model="creatObj.flag">
									<el-checkbox label="1">故障检修权限</el-checkbox>
									<el-checkbox label="2">设备安装权限</el-checkbox>
									<el-checkbox label="3">初始化权限</el-checkbox>
									<el-checkbox label="4">解绑设备权限</el-checkbox>
									<el-checkbox label="5">转卡权限</el-checkbox>
									<el-checkbox label="6">设备查看</el-checkbox>
									<el-checkbox label="7">快递物流</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</div>
					</div>
					<div class="communityBox" v-if="creatObj.flag.includes('6')">
						<span class="choice" @click="choiceCommunity">选择社区</span>
						<div v-for="(item,inx) in creatObj.communityCenterIdList" class="itemBox">
							<span>
								{{item.communityName}}
							</span>
						</div>
					</div>
				</div>

				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow1=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm4')">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="合同管理" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow2"
			width="55%">
			<el-form :model="accountsObj" :rules="rules" ref="ruleForm5" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox5">
					<div class="diaItem disBetween">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="请上传合同" prop="file">
								<div class="myinputBox myinputBox3">
									<el-upload class="avatar-uploader disBetween" :auto-upload="autoUpload"
										:on-progress="onProgress" :before-upload="beforeUpload" :on-change="getFile2"
										action="certmanage" :on-remove="handleRemove" :limit="1"
										:on-exceed="handleExceed" :file-list="fileList">
										<el-button size="small" type="primary">点击上传</el-button>
									</el-upload>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="保证金金额" prop="marginAmount">
								<div class="myinputBox">
									<el-input clearable type="number" v-model="accountsObj.marginAmount"
										placeholder="请输入保证金金额">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="合同结算周期" prop="contractSettlementCycle">
								<div class="myinputBox ">
									<el-radio-group v-model="accountsObj.contractSettlementCycle">
										<!-- <el-radio label="1" v-for="(item,inx) in cycleList" :key="inx"
											:label="item.value">{{item.text}}
										</el-radio> -->
										<el-radio label="1">月</el-radio>
										<el-radio label="2">季度</el-radio>
										<el-radio label="3">半年</el-radio>
										<el-radio label="4">年</el-radio>
									</el-radio-group>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="结算日期(次月)" prop="settlement">
								<div class="myinputBox ">
									<el-radio-group v-model="accountsObj.settlement">
										<el-radio label="1" v-for="(item,inx) in ement" :key="inx"
											:label="item.value">{{item.text}}
											<span v-if="inx!=3">号</span>
										</el-radio>
									</el-radio-group>
								</div>
							</el-form-item>
							<el-form-item v-if="accountsObj.settlement==4" class="lableBox nolableBox" label=""
								prop="settlementTime">
								<div class="myinputBox ">
									<el-input class="smallInput" type="number" clearable
										@input="numberChange(accountsObj.settlementTime,31)"
										v-model="accountsObj.settlementTime" placeholder="请输入结算日期">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="周期结算金额" prop="settlementAmount">
								<div class="myinputBox">
									<el-input clearable v-model="accountsObj.settlementAmount" type="number"
										placeholder="请输入周期结算金额">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="合同开始时间" prop="contractStartTime">
								<div class="myinputBox">
									<el-date-picker value-format="yyyy-MM-dd" v-model="accountsObj.contractStartTime"
										type="date" placeholder="请选择合同开始时间">
									</el-date-picker>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="合同有效期" prop="contractValidity">
								<div class="myinputBox ">
									<el-radio-group v-model="accountsObj.contractValidity">
										<el-radio label="1" v-for="(item,inx) in dityList" :key="inx"
											:label="item.value">{{item.text}}
											<span v-if="inx!=3">个月</span>
										</el-radio>
									</el-radio-group>
								</div>
							</el-form-item>
							<el-form-item v-if="accountsObj.contractValidity==4" class="lableBox nolableBox" label=""
								prop="contractValidityTime">
								<div class="myinputBox ">
									<el-input class="smallInput" type="number" clearable
										v-model="accountsObj.contractValidityTime" placeholder="请输入合同有效期">
									</el-input>

								</div>
							</el-form-item>
						</div>
					</div>

				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow2=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm5')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="visibleShow3 ">
			<img width="60%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: "contractorList",
		components: {},
		data() {
			let that = this;
			return {
				active: 0,
				props: {
					value: 'areaCode',
					label: 'areaName',
					lazy: true,
					lazyLoad(node, resolve) {
						const {
							level
						} = node;
						that.provinceFn(node.value || "").then((res) => {
							if (res.returnCode == 200) {
								var data = [];
								if (res.obj.type != 2) {
									data = res.obj.list
								} else {
									for (let k of res.obj.list) {
										data.push({
											areaCode: k.communityId,
											areaName: k.communityName
										})
									}
								}
								data.map(item => {
									item.leaf = res.obj.type == 2 //leaf如果是true就结束了，意味着没有下一级
									return item;
								})
								resolve(data);
							} else {
								resolve([]);
							}
						})
					}
				},
				flagList: [{
						text: "待审核",
						value: 1
					},
					{
						text: "合同待审核",
						value: 2
					},
					{
						text: "信息审核不通过",
						value: 3
					},
					{
						text: "合同审核通过缴纳保证金",
						value: 4
					},
					{
						text: "合同审核不通过",
						value: 5
					},
					{
						text: "保证金已缴纳",
						value: 6
					},
					{
						text: "保证金超时未缴纳",
						value: 7
					}
				],
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				props2: {
					label: 'areaName',
					value: "areaCode",
					isLeaf: 'leaf'
				},
				dialogDispose2: false,
				saveArr2: [],
				menuList2: [],
				autoUpload: false,
				fileList: [],
				accountsObj: {
					marginAmount: "",
					contractSettlementCycle: '',
					divideAccountProportion: null, //分账比例
					settlement: "",
					settlementTime: "",
					settlementAmount: "",
					contractValidity: "",
					contractValidityTime: ""
				},
				imageUrl: "",
				creatObj: {
					repairUserName: "", //人员名称
					repairUserId: "", //人员工号
					repairUserPhone: "", //联系电话
					repairUserType: "", //人员级别
					manageProvinceNo: "", //管辖省
					manageCityNo: "", //管辖市
					manageAreaNo: "", //管辖区
					repairUserStatus: "", //人员状态 1正常 2停工
					provinceNo: "", //家庭住址省
					cityNo: "", //运维人员
					areaNo: "", //家庭住址区
					address: "", //家庭住址详细地址
					communityIdList: [],
					flag: []
				},
				dialogVisible: false,
				visibleShow1: false,
				visibleShow2: false,
				visibleShow3: false,
				NOfalse: false,
				dialogTitle: "查看",
				statusList: [{
						text: "通过",
						value: 2
					},
					{
						text: "不通过",
						value: 3
					}
				],
				tableData: [],
				communityList: [],
				loading: false,
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 5, //当前页个数
					repairUserName: "",
					communityName: "",
				},
				options: [],
				areaList: [],
				areaValue: "",
				cycleList: [{
						text: "月",
						value: 1
					},
					{
						text: "季度",
						value: 2
					},
					{
						text: "半年",
						value: 3
					},
					{
						text: "年",
						value: 4
					}
				],
				ement: [{
						text: "5",
						value: 1
					},
					{
						text: "10",
						value: 2
					},
					{
						text: "15",
						value: 3
					},
					{
						text: "其他",
						value: 4
					}
				],
				dityList: [{
						text: "6",
						value: 1
					},
					{
						text: "12",
						value: 2
					},
					{
						text: "24",
						value: 3
					},
					{
						text: "其他",
						value: 4
					}
				],
				rules: {
					check: [{
						required: true,
						message: '请选择审核结果',
						trigger: 'change'
					}],
					checkContent: [{
						required: true,
						message: '请输入审核内容',
						trigger: 'blur'
					}],
					flag: [{
						required: true,
						message: '请至少选择一个权限',
						trigger: 'change'
					}],
					marginAmount: [{
						required: true,
						message: '请输入保证金金额',
						trigger: 'blur'
					}],
					settlement: [{
						required: true,
						message: '请选择结算日期',
						trigger: 'change'
					}],
					settlementTime: [{
						required: true,
						message: '请输入结算日期',
						trigger: 'blur'
					}],
					contractSettlementCycle: [{
						required: true,
						message: '请选择合同结算周期',
						trigger: 'change'
					}],
					settlementAmount: [{
						required: true,
						message: '请输入周期结算金额',
						trigger: 'blur'
					}],
					contractValidity: [{
						required: true,
						message: '请选择合同有效期',
						trigger: 'change'
					}],
					contractValidityTime: [{
						required: true,
						message: '请输入合同有效期',
						trigger: 'blur'
					}],
					contractStartTime: [{
						required: true,
						message: '请输入合同开始时间',
						trigger: 'blur'
					}],

				},
				fd1: new FormData(),
				fd2: new FormData(),
				dialogImageUrl: "",
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
				// this.getAreaList()
				// if (!(localStorage.getItem("areaList"))) {
				// 	this.getAreaList()
				// } else {
				// 	this.$set(this, "areaList", JSON.parse(localStorage.getItem("areaList")))
				// }
			})
		},
		methods: {
			choiceCommunity() {
				this.saveArr2 = JSON.parse(JSON.stringify(this.creatObj.communityCenterIdList))
				this.dialogDispose2 = true
			},
			savedialogDispose2() {
				this.dialogDispose2 = false
				this.$set(this.creatObj, "communityCenterIdList", this.saveArr2)
			},
			menuClick2(e, item, inx, ) {
				this.$nextTick(() => {
					if (e == false) {
						let index = this.saveArr2.findIndex((res) => {
							return res.communityId == item.communityId
						})
						if (index != -1) {
							this.saveArr2.splice(index, 1)
						}
					} else {
						this.saveArr2.push({
							communityId: item.communityId,
							communityName: item.communityName,
						})
					}
					this.$set(this.creatObj, "communityCenterIdList", this.saveArr2)

				})
			},
			nodeClick2(n, m, l) {
				if (n.leaf) {
					this.saveArr2 = JSON.parse(JSON.stringify(this.creatObj.communityCenterIdList))
					this.$api.listAreaInfoAndCommunity({
						parentAreaCode: n.areaCode
					}).then((res) => {
						console.log(res)
						for (let j of res.obj.list) {
							this.$set(j, "checkFlag", false)
							for (let k of this.creatObj.communityCenterIdList) {
								if (j.communityId == k.communityId) {
									console.log(j)
									this.$set(j, "checkFlag", true)
								}
							}
						}

						this.$set(this, "menuList2", res.obj.list)
					})
				}
			},
			loadNode2(node, resolve) {
				let id = ""
				if (node.data) {
					// if()
					id = node.data.areaCode
				}

				this.$api.listAreaInfoAndCommunity({
					parentAreaCode: id
				}).then((res) => {
					if (res.returnCode == 200) {
						if (res.obj.type == 1) {
							for (let k of res.obj.list) {
								if (node.level == 1) {
									if (node.data.areaName == "北京市" || node.data.areaName ==
										"天津市" ||
										node.data.areaName == "上海市" || node.data.areaName == "重庆市" || node
										.data
										.areaName == "香港特别行政区" || node.data
										.areaName == "澳门特别行政区") {
										k.leaf = true
									}
								} else if (node.level == 2) {
									k.leaf = true
								}
							}
							return resolve(res.obj.list)
						}
					}
				})
			},
			numberChange(val, maxNum, ) {
				//转换数字类型
				let num = Number(val)
				if (num < 0) {
					this.$set(this.accountsObj, "settlementTime", 0)
				}
				if (num > 31) {
					this.$set(this.accountsObj, "settlementTime", 31)
				}
			},
			tuDown(item) {
				console.log(item)
				if (item.electronicContractUrl) {
					window.open(this.$basImgUrl + item.electronicContractUrl)
				}
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.visibleShow3 = true;
			},
			getFile1(file, fileList) {
				this.fileList = fileList;
				let extName = file.name.substring(file.name.lastIndexOf('.') + 1);
				var AllUpExt = '.zip|.rar|.xls|.xlsx|.rtf|.doc|.docx|'
				if (AllUpExt.indexOf(extName) === -1) {
					this.$message.error('文件格式不正确!')
					// this.isDisable = true; //校验不正确不允许表单提交
					this.fileList = []
				} else {
					console.log(file)
					console.log(this.fileList)
					this.fd1.append('file', file.raw)
				}
			},
			getFile2(file, fileList) {
				this.fileList = fileList;
				let extName = file.name.substring(file.name.lastIndexOf('.') + 1);
				var AllUpExt = '.zip|.rar|.xls|.xlsx|.rtf|.doc|.docx|'
				if (AllUpExt.indexOf(extName) === -1) {
					this.$message.error('文件格式不正确!')
					// this.isDisable = true; //校验不正确不允许表单提交
					this.fileList = []
				} else {
					console.log(file)
					console.log(this.fileList)
					this.fd2.append('file', file.raw)
				}
			},
			onProgress() {

			},
			beforeUpload(file) {
				let type = file.name.slice(file.name.lastIndexOf(".") + 1)
				if (type == "rar" || type == "zip") {

				} else {
					this.$message.warning(`请上传格式为rar、zip等格式的压缩包`);
					reject()
				}
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`已经上传合同材料`);
			},
			changeList(n) {
				this.active = n
				// this.searchObj.pageNo = 1
				// this.PageInfo.pagenum = 1
				this.$nextTick(() => {
					// this.getData(n)
				})
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			exportData() {
				let obj = {
					repairUserName: this.searchObj.repairUserName,
					communityName: this.searchObj.communityName,
				}
				this.$api.exportContractor(obj, "承包商列表").then((res) => {
					if (res.returnCode == 200) {

					}
				})

			},
			provinceFn(id) {
				let data = {
					parentAreaCode: id,
				};
				return this.$api.listAreaInfo(data);
			},
			getStr(arr) {
				let str = ""
				if (arr[0] && arr[0]) {
					for (let k in arr) {
						if (k == arr.length - 1) {
							str += (arr[k].communityName)
						} else {
							str += (arr[k].communityName + ",")
						}
					}
				}
				return str
			},
			// 保存按钮点击事件 新建/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (formName == "ruleForm1") {
							if (this.fileList.length > 0) {
								this.fd1.append("contractId", this.creatObj.contractId)
								this.fd1.append("checkFlag", this.creatObj.check)
								if (this.creatObj.check == 3) {
									this.fd1.append("checkContent", this.creatObj.checkContent)
								} else {
									this.fd1.append("checkContent", "")
								}
								that.$api.checkAptitude(this.fd1).then((res) => {
									if (res.returnCode == 200) {
										that.$nextTick(() => {
											that.dialogVisible = false
											that.$message({
												message: '资质审核成功',
												type: 'success'
											});
											setTimeout(() => {
												// 刷新社区列表 和充电站   
												that.getData()
											}, 500)
										})
									}
								})
							} else {
								this.$message({
									message: "请上传合同材料",
									type: 'error'
								});
							}

						} else if (formName == "ruleForm4") {
							if (that.creatObj.flag.includes("1")) {
								that.creatObj.overhaulFlag = 2
							} else {
								that.creatObj.overhaulFlag = 1
							}
							if (that.creatObj.flag.includes("2")) {
								that.creatObj.installFlag = 2
							} else {
								that.creatObj.installFlag = 1
							}
							if (that.creatObj.flag.includes("3")) {
								that.creatObj.initializeFlag = 2
							} else {
								that.creatObj.initializeFlag = 1
							}
							if (that.creatObj.flag.includes("4")) {
								that.creatObj.bindFlag = 2
							} else {
								that.creatObj.bindFlag = 1
							}
							if (that.creatObj.flag.includes("5")) {
								that.creatObj.rechargeCardFlag = 2
							} else {
								that.creatObj.rechargeCardFlag = 1
							}
							if (that.creatObj.flag.includes("6")) {
								let arr = []
								for (let k of that.creatObj.communityCenterIdList) {
									arr.push(k.communityId)
								}
								if (arr.length > 0) {
									that.creatObj.communityFlag = 2
									this.$set(this.creatObj, "communityCenterIdList", arr)
								} else {
									that.$message({
										type: 'warning',
										message: '请至少选择一个社区!'
									});
									return false
								}
							} else {
								that.creatObj.communityFlag = 1
							}
							if (that.creatObj.flag.includes("7")) {
								that.creatObj.expressFlag = 2
							} else {
								that.creatObj.expressFlag = 1
							}
							that.$api.updateOrderRepairUser(that.creatObj).then((res) => {
								if (res.returnCode == 200) {
									that.$message({
										type: 'success',
										message: '修改成功!'
									});
									setTimeout(() => {
										that.getData()
									}, 500)
									this.visibleShow1 = false
								}
							})
						} else if (formName == "ruleForm5") {
							if (this.fileList.length > 0) {
								this.fd2.append("contractId", this.accountsObj.contractId)
								this.fd2.append("marginAmount", this.accountsObj.marginAmount)
								this.fd2.append("settlementAmount", this.accountsObj.settlementAmount)
								this.fd2.append("contractStartTime", this.accountsObj.contractStartTime)
								this.fd2.append("contractSettlementCycle", this.accountsObj
									.contractSettlementCycle)
								if (this.accountsObj.settlement == 4) {
									this.fd2.append("settlementTime", this.accountsObj.settlementTime)
								} else {
									this.fd2.append("settlementTime", this.getName(this.accountsObj.settlement,
										this.ement))
								}
								if (this.accountsObj.contractValidity == 4) {
									this.fd2.append("contractValidityTime", this.accountsObj.contractValidityTime)
								} else {
									this.fd2.append("contractValidityTime", this.getName(this.accountsObj
										.contractValidity, this.dityList))
								}
								console.log(this.accountsObj)
								console.log(this.fd2)
								that.$api.setContract(this.fd2).then((res) => {
									if (res.returnCode == 200) {
										that.$nextTick(() => {
											that.visibleShow2 = false
											that.$message({
												message: '合同上传成功',
												type: 'success'
											});
											setTimeout(() => {
												// 刷新社区列表 和充电站   
												that.getData()
											}, 500)
										})
									}
								})
							} else {
								this.$message({
									message: "请上传合同材料",
									type: 'error'
								});
							}
						}

					} else {
						return false;
					}
				});

			},
			// 审核
			itemClick(item, n) {
				let that = this
				if (n == 1) {
					this.fileList = []
					if (item.checkFlag == 1) {
						this.dialogTitle = "资质审核"
					} else {
						this.dialogTitle = "查看"
					}
					this.$api.viewContractor({
						contractId: item.contractId
					}).then((res) => {
						if (res.returnCode == 200) {
							this.$set(this, "creatObj", res.obj)
							this.$set(this.creatObj, "flag", [])
							this.$set(this.creatObj, "contractId", item.contractId)
							this.dialogVisible = true
							this.$nextTick(() => {
								this.$refs.ruleForm1.clearValidate()
							})
						}
					})

				} else if (n == 3) {

					this.$api.viewContractor({
						contractId: item.contractId
					}).then((res) => {
						if (res.returnCode == 200) {
							this.$set(this, "creatObj", res.obj)
							this.$set(this.creatObj, "flag", [])
							if (res.obj.overhaulFlag == 2) {
								this.creatObj.flag.push("1")
							}
							if (res.obj.installFlag == 2 || res.obj.installFag == 2) {
								this.creatObj.flag.push("2")
							}
							if (res.obj.initializeFlag == 2) {
								this.creatObj.flag.push("3")
							}
							if (res.obj.bindFlag == 2) {
								this.creatObj.flag.push("4")
							}
							if (res.obj.rechargeCardFlag == 2) {
								this.creatObj.flag.push("5")
							}
							if (res.obj.communityFlag == 2) {
								this.creatObj.flag.push("6")
							}
							if (res.obj.expressFlag == 2) {
								this.creatObj.flag.push("7")
							}
							console.log(this.creatObj)
							this.visibleShow1 = true
							this.$nextTick(() => {
								this.$refs.ruleForm4.clearValidate()
							})
						}
					})
				} else if (n == 4) {
					this.fileList = []
					this.visibleShow2 = true
					this.$set(this.accountsObj, "contractId", item.contractId)
				} else if (n == 2) {
					this.$confirm('是否确认删除该运维承包商?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						console.log(item)
						that.$api.deleteContract({
							contractId: item.contractId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									that.getData()
								}, 500)
							}
						})

					}).catch(() => {

					});
				}
			},
			// 省市区数据
			getAreaList() {
				this.$api.listAreaInfo({
					"parentAreaCode": ""
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "areaList", res.obj.list)
						// localStorage.setItem('areaList', JSON.stringify(res.obj))
					}
				})
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			toSearch() {
				this.$set(this.PageInfo, "pagenum", 1)
				this.$set(this.searchObj, "pageNo", 1)
				this.getData()
			},
			getData(n) {
				this.loading = true
				this.$api.listContractor(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "tableData", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total || 0)
						this.loading = false
					}
				})
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData({})
			},
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()

				console.log(nodesInfo)
				if (nodesInfo.length > 0) {
					this.$set(this.searchObj, "communityName", nodesInfo[0].label || "")
				} else {
					this.$set(this.searchObj, "communityName", "")
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./contractorList.scss";
</style>